import Api from '@/resource/Api';
import store from '@/store';
import Helper  from '@/resource/Helper';

export async function switchAccountAdmin(switch_id) {
    const url = `${process.env.VUE_APP_CORENROLL_SYSTEM}/admin-group-switch-login`;
    
    try {
        const data = {
            switch_id: switch_id
        };
        const res = await Api.post(url, data, url);
        if (res?.data?.status === 'success') {
            store.commit('setAuthentication', true);
            
            const switchSuccess = Helper.switchAccount(res.data);
            if (!switchSuccess) {
                throw new Error('Failed to switch account state');
            }
            
            this.$notify('Successfully switched account', 'success');
            return true;
        } else {
            throw new Error(res?.data?.message || 'Invalid response from server');
        }
    } catch (err) {

        console.error('Account switch error:', err);
        this.$notify(
            err?.response?.data?.message || 'Failed to switch account. Please try again.',
            'error'
        );
        this.$router.replace("/login");
    }
}
